var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLevelHigh = function SvgLevelHigh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    fillRule: "evenodd",
    d: "M12.05 2.35a1.35 1.35 0 0 1 2.7 0v11.3a1.35 1.35 0 1 1-2.7 0zm-5.4 3a1.35 1.35 0 0 1 2.7 0v8.3a1.35 1.35 0 1 1-2.7 0zM2.6 7a1.35 1.35 0 0 0-1.35 1.35v5.3a1.35 1.35 0 1 0 2.7 0v-5.3A1.35 1.35 0 0 0 2.6 7",
    clipRule: "evenodd"
  })));
};
export { SvgLevelHigh as ReactComponent };